var webScreen = 1000;
var webScreenMax = 1650;


// Window onresize event
new ResizeObserver(() => {
  if ( window.innerWidth >= webScreen ){
    // Desktop & megamenu
    // setMegamenu(); 
    setMegamenuSize(window.innerWidth)
    setPromoSliderMobile('destroy')
  } else {
    // Mobile
    setPromoSliderMobile('show');
  }
}).observe(document.body)

function setMegamenu(){
  let mainMenuLinks = document.querySelectorAll('.has-level2-submenu');
  let allMegamenus = document.querySelectorAll(".has-level2-submenu > .nav-dropdown");

  // Add event listner
  mainMenuLinks.forEach(e=>{ 
    e.addEventListener("mouseenter", (event) => { megamenuTrigger(e, allMegamenus, 'show') }); //Apply hover effect
  });
}

function setMegamenuMobile(){
  console.log('--setMegamenuMobile')
  // This function replace <button> tag to <a> tag after checking if the link has submenu
  var mThirdLevelLinks = document.querySelectorAll('.mobile-menu__panel.mm-sub-wrap button.mobile-menu__nav-link')
  mThirdLevelLinks.forEach(function(e){
    let panelID = e.getAttribute('aria-controls')

    if ( $(`#${panelID} li.mobile-menu__nav-item`).length > 0 ){
      // Has submenu
    }else {
      let link = $(e).attr('data-href')
      let title = $(e).text();
      $(e).replaceWith(`<a class="mobile-menu__nav-link" href="${link}">${title}</a>`)
    }
    
  });
}
function setMegamenuSize(currentWindowWidth){
  let targetNavWidth = currentWindowWidth - 50; // remove side padding
  let transformScale = (targetNavWidth * 100 / 1600).toFixed(0) // eg. 84

  if (currentWindowWidth <= webScreenMax){
    // Transform scale for cover desktop window size
    $('.nav-dropdown.mg2023').css('transform', `scale(${transformScale}%, ${transformScale}%)`);
  } else {
    // Window size is larger 'webScreenMax' (1650) --> revert the size back to normal
    $('.nav-dropdown.mg2023').css('transform', `scale(1, 1)`);
  }
}

function megamenuTrigger(e, allMegamenus, status){
  let megamenuNode = $(e).find('.level2-submenu');

  if (status == 'show'){
    // hide all other opened menus
    $('.has-level2-submenu').removeClass('is-dropdown-open');
    $('.has-level2-submenu .nav-dropdown__link').attr('aria-expanded', 'false');
    allMegamenus.forEach(e=>{ 
      $(e).attr('aria-hidden', 'true')
    });

    // Display menu
    $(e).addClass('is-dropdown-open')
    $(e).find('.nav-dropdown__link').attr('aria-expanded', 'true');

    megamenuNode.attr('aria-hidden', 'false');
    megamenuNode.on("mouseleave", (event) => { megamenuTrigger(e, 'hide')});
    
    // Display CTA wrapper
    $('.submenu-level2-cta-wrap').removeClass('hidden');
  }else {
    // Hide menu
    $('.has-level2-submenu').removeClass('is-dropdown-open')
    megamenuNode.attr('aria-hidden', 'true');
    // allMegamenus.forEach( e =>{ e.classList.add('hide') }); // Hide all megamenu when mouse isn't on megamenu area
        
    // Hide CTA wrapper
    $('.submenu-level2-cta-wrap').addClass('hidden');
  }
  
  
}

function setPromoSliderMobile(status){
  let activeSlider = status == 'show' ? true : false;
  let cycleSpeed = $('.cyclespeed').text();
  // options
  let options = {
    draggable: '>1',
    fade: 'fade',
    autoPlay: cycleSpeed,
    prevNextButtons: false
  }

  var $mobilePromoSliderInMegamenu = $('#promo-mobile-slider-wrap').flickity(options);
  
  // Active or destroy slider
  if ( !activeSlider ) {
    // destroy Flickity
    $mobilePromoSliderInMegamenu.flickity('destroy');
  } else {
    // init new Flickity
    $mobilePromoSliderInMegamenu.flickity(options);
  }
  activeSlider = !activeSlider;

}

function setMegaMenuMasonry(){
  let elem = document.querySelectorAll('.nav-dropdown--three-columns.use-masonry');
  let masonryOption = { 
    itemSelector: '.masonry-item', 
    columnWidth: '.masonry-item', 
    percentPosition: 'true',
    fitWidth: 'true' 
  };
  for (let i = 0 ; i< elem.length; i++){
    new Masonry(elem[i], masonryOption);
  }
}
document.addEventListener("DOMContentLoaded", function() {
  setMegaMenuMasonry()
  setMegamenuMobile();
});
